/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuInputRangeDimensions_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterDimensions_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterDimensions_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuInputRangeDimensions_searchBrowse$ref,
  +$refType: SbRespRefineMenuFilterDimensions_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '26b557778714d08edd379f113368daea';
module.exports = node;
